import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Catch-all route for the renamed `/s/tailscale-login` subtree.
 *
 * The subtree was renamed to `/s/login`. To keep old links (bookmarks, the
 * tailscale CLI, external references) working, this splat route redirects any
 * `/s/tailscale-login/*` path to its equivalent under the new `/s/login/*` name,
 * preserving the remaining path and any search params.
 */
export const Route = createFileRoute("/_static/s/tailscale-login/$")({
    beforeLoad: ({ params, location }) => {
        throw redirect({
            replace: true,
            href: `/s/login/${params._splat ?? ""}${location.searchStr}`,
        });
    },
});
